import { render } from "./quiz-v1-pagination.vue?vue&type=template&id=2b7436d2&scoped=true"
import script from "./quiz-v1-pagination.vue?vue&type=script&lang=js"
export * from "./quiz-v1-pagination.vue?vue&type=script&lang=js"

import "./quiz-v1-pagination.vue?vue&type=style&index=0&id=2b7436d2&lang=sass&scoped=true"

import exportComponent from "../../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b7436d2"]])

export default __exports__